// extracted by mini-css-extract-plugin
export default {"tableHeader":"KpiBetweenSchools_tableHeader__svRou","groupBorder":"KpiBetweenSchools_groupBorder__4uN0+"};